export default __webpack_public_path__ + "static/media/miniape.4f80a703.png";